import(/* webpackMode: "eager" */ "/vercel/path0/app/trending/page.tsx");
